export default "__VITE_ASSET__Dj4Q1fQy__"